module.exports = __webpack_public_path__ + "static/Add-YouTube-Video-2-e1403554507847-3c7489d8452febe1de2335c4b8e97ace.jpg";